// THE SEAM LAB's body hold (tools/seamlab.mjs; APP_WORKFLOW §2 "Seam lab"). Dev-only:
// active only with `?seam=1` in the game URL; without it seamDrive is one boolean test.
// The lab sets `window.__seamPose = { x, y, z, yaw, pitch, jet }` (y = the EYE, m a.s.l.)
// BEFORE a tick; the tick then puts the body exactly there in place of player.step (as
// the device bench's benchDrive does: no physics, no real-time dt, no ground clamp), so
// the game camera — and every uniform the frame derives from it — is the route's pose,
// the same in every run and every arm. `null` = the player steps as usual.
import { WebGLRenderTarget, DepthTexture, PerspectiveCamera, SRGBColorSpace, UnsignedIntType, Box3, Sphere, Vector3 } from 'three';

export const SEAM = typeof location !== 'undefined' && /[?&]seam=1(?:&|$)/.test(location.search);
// the lab's in-page half (tools/seamlab/page.js) builds its targets with the bundle's own three
if (SEAM) window.__seamThree = { WebGLRenderTarget, DepthTexture, PerspectiveCamera, SRGBColorSpace, UnsignedIntType, Box3, Sphere, Vector3 };

// one tick's drive: true = the body was placed (the caller skips player.step)
export function seamDrive({ player, flat, hf }) {
  if (!SEAM) return false;
  const p = window.__seamPose;
  if (!p) return false;
  if (hf && hf.ensureAround) hf.ensureAround(p.x, p.z);
  player.pos.set(p.x, p.y - (player.eye || 0), p.z);
  player.vel.set(0, 0, 0);
  player.speed = 0;
  player.state = p.jet ? 'glide' : 'ground';
  player.gliding = !!p.jet;
  player.grounded = !p.jet;
  if (flat) { flat.lookYaw = p.yaw; flat.lookPitch = p.pitch; }
  player.yaw = p.yaw;
  return true;
}
